import { errorColorScale } from "./error.colors.js";
import { neutralVariantColorScale } from "./neutral-variant.colors.js";
import { neutralColorScale } from "./neutral.colors.js";
import { primaryColorScale } from "./primary.colors.js";
import { secondaryColorScale } from "./secondary.colors.js";
import { successColorScale } from "./success.colors.js";
import { tertiaryColorScale } from "./tertiary.colors.js";
import { warningColorScale } from "./warning.colors.js";
export const colorTokens = {
    primary: primaryColorScale,
    secondary: secondaryColorScale,
    tertiary: tertiaryColorScale,
    error: errorColorScale,
    warning: warningColorScale,
    success: successColorScale,
    neutral: neutralColorScale,
    neutralVariant: neutralVariantColorScale,
};
export default colorTokens;
